const audioList = [
   {
      name: 'Freddie Freeloader',
      singer: 'Miles Davis',
      cover:
      'https://firebasestorage.googleapis.com/v0/b/host-medias-b0b6d.appspot.com/o/Miles-ALbum-150.png?alt=media&token=75c275b9-a9a8-486b-94bc-066c83cd0bf0',
      musicSrc:
      'https://firebasestorage.googleapis.com/v0/b/host-medias-b0b6d.appspot.com/o/yt1s.com%20-%20Miles%20Davis%20%20Freddie%20Freeloader%20Audio.mp3?alt=media&token=48832f4d-3acc-4992-947a-a41561f73886'
   },
   { 
      name: 'Bird and Diz',
      singer: 'Charlie Parker',
      cover:
      'https://firebasestorage.googleapis.com/v0/b/host-medias-b0b6d.appspot.com/o/Charlie-140.png?alt=media&token=5a49159f-c1f1-46ec-87aa-0f337c600eea',
      musicSrc:
      'https://firebasestorage.googleapis.com/v0/b/host-medias-b0b6d.appspot.com/o/Charlie%20Parker%20-%20Bird%20and%20Diz%20(1952).mp3?alt=media&token=a4c5f6e3-9122-40e3-8b4d-438943e8bc56'
   },
]

export default audioList